import { Flex } from '@chakra-ui/react';
import React from 'react';
import ProjectsCard from './Card/index';

export default function Projects() {
  return (
    <div>
      <Flex
        direction="row"
        align="center"
        m="0 auto"
        wrap="wrap"
        justify="center"
        width={{ sm: '100%', md: '90%', lg: '80%' }}
      >
        <ProjectsCard />
      </Flex>
    </div>
  );
}
